import "./theme/css/font-awesome.css";
import "./theme/css/style.css";
import "./theme/css/jquery.bxslider.css";
window.jQuery = window.$ = require('jquery');
require("./theme/js/jquery.bxslider.js");
import 'vue-select/dist/vue-select.css'
import "./styles/_guest.scss";